export default {
  title: 'Tabletă de fidelizare',
  headers: {
    customer_frequency: 'Frecvența clienților',
  },
};
